import { useCallback } from "react";

import { useDispatch, useSelector } from "react-redux";

import { fetchSearchQuotaThunk } from "app/pages/sales-intelligence/sub-modules/advanced-search/store/effects";
import {
    selectIsSearchQuotaLoading,
    selectSearchQuota,
} from "app/pages/sales-intelligence/sub-modules/advanced-search/store/selectors";

import type { SearchQuotaDto } from "../types";

type HookValue = {
    readonly isQuotaReached: boolean;
    readonly isLoading: boolean;
    readonly data: SearchQuotaDto;
    readonly fetch: VoidFunction;
};

export const useSearchResultsQuota = (): HookValue => {
    const dispatch = useDispatch();

    const data = useSelector(selectSearchQuota);
    const isLoading = useSelector(selectIsSearchQuotaLoading);

    const fetch = useCallback((): void => {
        void dispatch(fetchSearchQuotaThunk());
    }, []);

    return { data, fetch, isLoading, isQuotaReached: data.remaining === 0 };
};
